/**
 * @name Badge
 * @description Componente para mostrar un badge
 * @author Ricardo Guerra
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { Typography } from '@tycommon/styles';

const Badge = (props) => {
  const { showBadge, showDot, color, backgroundColor, children } = props;

  return (
    <Styled.Badge showBadge={showBadge} color={color} backgroundColor={backgroundColor}>
      {showDot && <Styled.Dot color={color} />}
      {children}
    </Styled.Badge>
  );
};

Badge.propTypes = {
  // Boolean para mostrar componente badge.
  showBadge: PropTypes.bool,
  // Boolean para mostrar componente dot.
  showDot: PropTypes.bool,
  // Color del componente.
  color: PropTypes.string,
  // Color background del componente.
  backgroundColor: PropTypes.string,
  // React Component.
  children: PropTypes.node.isRequired
};

// *************************************
// STYLED COMPONENTS                               
// *************************************

const Styled = {};

Styled.Badge = styled.div`
  display: flex;  
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  width: fit-content;
  ${(props) => props.showBadge && css`
    padding: 4px 12px;
    border-radius: 12px;
    background-color: ${(props) => props.backgroundColor ? props.backgroundColor : props.theme.colors.greyHover};
    color: ${(props) => props.color ? props.color : props.theme.colors.greyDark};
    & > ${Typography.Text} { color: ${(props) => props.color ? props.color : props.theme.colors.greyDark} !important; }
    & > ${Typography.Medium} { color: ${(props) => props.color ? props.color : props.theme.colors.greyDark} !important; }
  `};
`;

Styled.Dot = styled.div`
  width: 8px;
  height: 8px; 
  min-width: 8px;
  min-height: 8px;
  border-radius: 50%; 
  margin-right: 8px;
  background-color: ${(props) => props.color ? props.color : props.theme.colors.greyDark};
`;

export default Badge;
